<template>
  <div class="logo-overlay">
    <template v-if="logoLink">
      <div class="logo-image" :style="{ backgroundImage: `url(${logoLink})` }"></div>
    </template>
    <template v-else>
      <div class="logo-empty">{{ logoEmptyText }}</div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    logoLink: String,
    projectName: String,
  },
  computed: {
    logoEmptyText() {
      if (this.$validate.isNotString(this.projectName)) {
        return null;
      }

      return this.projectName.charAt(0).toLowerCase();
    },
  },
};
</script>

<style lang="sass" scoped>
  .logo-overlay
    width: 60px
    height: 60px
    background-color: transparent
    overflow: hidden
    border-radius: 50%
    box-sizing: border-box

  .logo-image
    width: 100%
    height: 100%
    background-repeat: no-repeat
    background-size: cover
    background-position: center
    border-radius: 50%

  .logo-empty
    width: 100%
    height: 100%
    display: flex
    align-items: center
    justify-content: center
    font-size: 24px
    line-height: 20px
    font-weight: 500
    color: rgba(33, 33, 33, .25)
    text-transform: uppercase
    background-color: #ade3fb
    border-radius: 50%
</style>
